var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-form-select',{attrs:{"state":_vm.isDropDownValidation,"text-field":"name","value-field":"id","options":_vm.aclList},on:{"input":function($event){return _vm.onSelectListItem($event)}},model:{value:(_vm.selection),callback:function ($$v) {_vm.selection=$$v},expression:"selection"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }